import { CONSENT_STORAGE_KEY } from "@/features/consent/consent-storage";

// Google Ads gtag.js bootstrap using Consent Mode v2. The ad signals default
// to "denied" so no advertising cookies are set before the visitor opts in,
// but gtag.js still loads on every page (unlike the TikTok pixel) so Google can
// model conversions from consented traffic.
//
// We seed the default from any *already* persisted marketing choice: a
// returning, consented visitor is then tracked from the first paint without
// waiting for React to hydrate and run the consent effect. Mid-session changes
// are handled live by `applyGoogleAdsConsent`.
//
// `url_passthrough` is the one lever that buys real consent-free measurement
// here: with `ad_storage: 'denied'` there is no cookie to carry the click id,
// so gtag appends `gclid`/`wbraid` to internal navigations instead. Conversions
// from non-consenting visitors can then still be attributed to the click that
// paid for them, without anything being stored on the device. Ad *cookies* and
// any identifier sharing stay strictly behind the marketing category.
//
// `analytics_storage` is wired to the analytics category rather than pinned
// 'denied'. Google Ads itself doesn't read it — it's GA4's signal — but leaving
// it hardcoded would silently mis-declare consent the day a GA4 tag lands.
export function googleAdsBootstrapSnippet(googleAdsId: string): string {
  return `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
var markaMarketing = 'denied';
var markaAnalytics = 'denied';
try {
  var markaConsent = JSON.parse(localStorage.getItem(${JSON.stringify(CONSENT_STORAGE_KEY)}) || '{}');
  if (markaConsent && markaConsent.marketing === 'granted') { markaMarketing = 'granted'; }
  if (markaConsent && markaConsent.analytics === 'granted') { markaAnalytics = 'granted'; }
} catch (e) {}
gtag('consent', 'default', {
  ad_storage: markaMarketing,
  ad_user_data: markaMarketing,
  ad_personalization: markaMarketing,
  analytics_storage: markaAnalytics,
  wait_for_update: 500
});
gtag('set', 'url_passthrough', true);
gtag('js', new Date());
gtag('config', ${JSON.stringify(googleAdsId)});`;
}
